import { createCommand } from 'lexical'

import { InsertLinkPayload, ToggleLinkPayload } from './interface'

export const INSERT_LINK_COMMAND = createCommand<InsertLinkPayload>(
  'INSERT_LINK_COMMAND'
)

export const TOGGLE_LINK_COMMAND = createCommand<ToggleLinkPayload>(
  'TOGGLE_LINK_COMMAND'
)
